import React from "react";
import {connect} from "react-redux";
import {Layout} from 'antd';
import {
    notifyRead,
    triggerBotState,
    triggerConversationsFetch,
    triggerStompConnection,
    triggerStompSubscription,
    unsubscribeSession
} from "../../epics/conversations";
import {CHATS} from '../../reducers/router';
import ConversationList from "./ConversationList"
import ChatDialog from '../dialog/ChatDialog';
import BotPauseBotton from './BotPauseButton';
import webstomp from 'webstomp-client';
import SockJS from 'sockjs-client';
import Message from '../dialog/message';

import {RECEIVED_CONVERSATION_MESSAGE, SUBSCRIBE_CONVERSATION} from "../../reducers/conversations";


const { Sider } = Layout;

class Chats extends React.Component {

    sendMessage = (msg) => {
        if (this.props.session.stomp) {
            this.stomp.send(`/app/conversation/${this.props.chat}`, msg);
        }
    };

    constructor(props) {
        super(props);

        const socket = new SockJS('/api/ws');
        this.stomp = webstomp.over(socket);
    }

    toggleBotPaused = (enabled) => {
        triggerBotState(this.props.dispatch, this.props.chat, enabled);
    };

    componentWillMount() {
        console.log("Chats will mount");
        triggerStompConnection(this.props.dispatch, this.stomp);
        triggerConversationsFetch(this.props.dispatch);
    }

    componentWillUnmount() {
        if (this.stomp && this.stomp.connected) {
            this.stomp.disconnect();
        }
    }

    componentWillReceiveProps(nextProps) {
        console.log("next props", nextProps);
        if (nextProps.session.stomp) {
            const conversations = nextProps.session.conversations;
            const subscriptions = nextProps.session.subscriptions;
            const unread = nextProps.session.unread;
            const selectedConversation = nextProps.chat;

            if (!conversations[selectedConversation]) {
                this.props.dispatch({
                    type: CHATS
                });
            }

            Object.keys(conversations).forEach(conversation => {
                if (!Object.keys(subscriptions).includes(conversation)) {

                    const config = {
                        stomp: this.stomp,
                        location: `/topic/conversation/${conversation}`,
                        conversation: conversation,
                        handler: (rawMessage) => {
                            const message = JSON.parse(rawMessage.body);
                            return {
                                type: RECEIVED_CONVERSATION_MESSAGE,
                                message: new Message(message.content, message.sender !== 'USER', message.sender),
                                id: conversation
                            }
                        }
                    };
                    console.log("triggering subscription", config);
                    triggerStompSubscription(this.props.dispatch, config);

                    this.props.dispatch({
                        type: SUBSCRIBE_CONVERSATION,
                        id: conversation,
                        //subscription
                    });

                }
            });

            Object.keys(subscriptions).forEach(subscription => {
                if (!Object.keys(conversations).includes(subscription)) {
                    unsubscribeSession(this.props.dispatch, subscription, subscriptions[subscription]);
                }
            });

            if (unread[selectedConversation] && unread[selectedConversation].length > 0) {
                notifyRead(this.props.dispatch, selectedConversation, unread[selectedConversation]);
            }
        }

    }

    render() {

        const chat = this.props.chat;
        const conversations = this.props.session.conversations;

        const unread = this.props.session.unread;

        let messages = [];
        if (chat && conversations[chat]) {
            messages = conversations[chat];
        }

        const paused = this.props.session.paused.indexOf(chat) >= 0;
        return (
            <Layout>
                <Sider style={{ overflow: 'auto', height: 'calc(100vh - 66px)'}}>
                    <ConversationList conversations={conversations} unread={unread}/>
                </Sider>

                    { chat?
                        <Layout>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                padding: 10,
                                backgroundColor: '#bfbcbc'
                            }}><BotPauseBotton style={{alignSelf: 'flex-end'}} paused={paused}
                                               toggle={this.toggleBotPaused}/></div>
                            <ChatDialog send={this.sendMessage} messages={messages}/>
                        </Layout>
                        : <h1 style={{width: '100%', alignSelf: 'center', textAlign: 'center'}}>Please select a
                            conversation</h1>
                    }
            </Layout>
        )
    }
}


const mapState = ({session}) => ({session});
export default connect(mapState)(Chats)



// WEBPACK FOOTER //
// ./src/components/admin/Chats.js